module.exports = __webpack_public_path__ + "static/movie-palace-a7de736d8a5eb46863dceaf8aa62bcf1.webp";